import React from 'react'
import Highcharts, { chart } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { headingBlue, lightBlue, maroon, mediumGrey, orange, skyBlue } from '../../assets/colors';
import CustomDropDown from '../CustomDropDown';
import { Box, IconButton, Typography } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'

// require('highcharts/modules/bar')(Highcharts);

const HBChart = (props) => {
    const chartOptions = {
        chart: {
            type: props?.type || 'bar',
            height: props?.height || (props?.type === 'column' ? 320 : Math.max(((props?.data?.data?.length || props?.data?.length || 10) * 25), 300)),
            events: {
                load: function () {
                    if (props?.updateCaller) {
                        const chart = this;
                        chart.container.addEventListener('click', function (e) {
                            const target = e.target;
                            console.log("targetr:", target.outerHTML)

                            if (!target.classList.contains('hc-axis-label')) return;

                            const labelText = target.textContent.trim();
                            props?.updateCaller(labelText)

                        })
                    }
                }
            }
        },
        title: {
            text: props.title,
            style: { color: headingBlue, fontSize: '1rem' }
        },
        xAxis: {
            categories: props?.data?.data?.map(item => props?.xValue ? item[props?.xValue] : item['district'] + ' - ' + item.gender[0]),
            title: {
                text: props.xTitle,
                style: { color: headingBlue, fontSize: '1rem', fontWeight: 500 }
            },
            labels: {
                useHTML: true,
                formatter: function () {
                    const index = this.pos;
                    const gender = props.data.data[index]?.gender;
                    const color = gender === 'Male' ? headingBlue : orange;
                    return `
                    <span
                    class="hc-axis-label"
                    style="cursor:pointer;color:${headingBlue}"
                    >
                    ${this.value}
                    </span>
                `;
                },
                style: {
                    cursor: 'pointer'
                },
                // events: {
                //     click: function(e) {
                //         console.log('Clicked......')
                //     }
                // }
            }
            // labels: {
            //     style: {
            //         color: headingBlue,
            //         fontSize: '0.9rem',
            //         // fontWeight: 500
            //     }
            // }
        },
        yAxis: {
            title: {
                text: props.yTitle,
                style: { color: headingBlue, fontSize: '1rem', fontWeight: 500 }
            },
            labels: {
                style: {
                    color: headingBlue,
                    fontSize: '0.9rem',
                    // fontWeight: 500
                }
            },
        },
        // tooltip: {
        //     useHTML: true,
        //     formatter: function () {
        //         const p = this.point
        //         console.log("P: ", p)
        //         return `${p}`                   
        //     }
        // },
        plotOptions: {
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: function() {
                            if (props?.onChartClick || props?.updateCaller) {
                                const fn = props.onChartClick || props.updateCaller;
                                fn(this.category);
                            }
                        }
                    }
                }
            },
            bar: {
                pointWidth: 10,
                dataLabels: {
                    enabled: true
                }
            },
            column: {
                maxPointWidth: 50,
                dataLabels: {
                    enabled: true
                }
            },
            // pointPadding: 0.01
        },
        series: [
            {
                name: props?.seriesValue ? props.seriesValue : 'Leads',
                data: props?.data?.data?.map(item =>
                ({
                    y: props.yValue ? item[props.yValue] : item.totalLeads,
                    color: item.color ? item.color : (props.color ? props.color : (item.gender === 'Male' ? skyBlue : (item.gender === 'Female' ? orange : headingBlue)))
                })
                ),
                showInLegend: false
            },
        ],
        credits: { enabled: false }
    }
    return (
        <>
            <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <IconButton size='small'
                    onClick={() => {
                        if (props.page > 1) {
                            props.updatePage(props.page - 1)
                        }
                    }}
                    disabled={!props.page || props.page <= 1}
                ><KeyboardArrowLeft size='small'
                    sx={{ color: (!props.page || props.page <= 1) ? mediumGrey : headingBlue }}
                    /></IconButton>
                <Typography style={{ color: maroon, fontSize: '0.9rem', padding: '0.5rem 0.2rem 0.5rem 0.2rem' }}>
                    {props?.data?.totalRecords != null
                        ? (props.data.totalRecords === 0
                            ? '0 of 0'
                            : `${(props.page - 1) * 10 + 1} - ${Math.min(props.page * 10, props.data.totalRecords)} of ${props.data.totalRecords}`)
                        : (props?.data?.data?.length ? `${props.data.data.length} records` : '')}
                </Typography>
                <IconButton size='small'
                    onClick={() => {
                        if (props.page < props?.data?.totalPages) {
                            props.updatePage(props.page + 1)
                        }
                    }}
                    disabled={!props?.data?.totalPages || props.page >= props.data.totalPages}
                ><KeyboardArrowRight size='small'
                    sx={{ color: (!props?.data?.totalPages || props.page >= props.data.totalPages) ? mediumGrey : headingBlue }}
                    /></IconButton>
            </Box>
            <HighchartsReact highcharts={Highcharts} options={chartOptions}>
            </HighchartsReact>
        </>

    )
}

export default HBChart
